import {
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonModal,
  IonPage,
  IonRow,
} from "@ionic/react";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import MeasuringTape from "../components/modals/measuring-tape";
import TopLeftUserName from "../components/TopLeftUserName";

const ReportPage: React.FC = () => {
  const [measuringModal, setShowModal] = useState(false);
  return (
    <IonPage placeholder={undefined}>
      <IonModal
        className="assessment-tape-modal-wrap"
        backdropDismiss={false}
        isOpen={measuringModal}
        placeholder={undefined}
      >
        <MeasuringTape setShowModal={setShowModal}></MeasuringTape>
      </IonModal>
      <IonHeader className="ion-no-border" placeholder={undefined}>
        <TopLeftUserName headerText={"Full Visit Summary"}></TopLeftUserName>
        <div className="main-heading">
          <h1>Gait Analysis Report</h1>
        </div>
      </IonHeader>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid className="container report-page" placeholder={undefined}>
          {/* <IonRow className="row">
            <IonCol className="col-sec">
              <div className="main-heading">
                <h1>Gait Analysis Report</h1>
              </div>
            </IonCol>
          </IonRow> */}
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="report-user-data">
                <ul>
                  <li>Friday, June 24, 2022</li>
                  <li>11:35 AM</li>
                  <li>James Baker</li>
                  <li>Dr. John Cooper</li>
                </ul>
              </div>
            </IonCol>
          </IonRow>
          <IonRow className="row report-graph-sec" placeholder={undefined}>
            <IonCol size="6" className="col-sec" placeholder={undefined}>
              <div className="graph-text">
                <h2>Fall Risk</h2>
                <h3>24%</h3>
                <h4>Low</h4>
              </div>
            </IonCol>
            <IonCol size="6" className="col-sec" placeholder={undefined}>
              <div className="graph-text">
                <h2>Fall Risk</h2>
                <h3>24%</h3>
                <h4>Low</h4>
              </div>
            </IonCol>
          </IonRow>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="report-mobility-sec">
                <div className="mobility-level">
                  <h2>Mobility Level</h2>
                </div>
                <div className="mobility-bar-wrap high">
                  <h3>High</h3>
                  <div className="mobility-bar">
                    <span></span>
                  </div>
                </div>
                {/* <div className="mobility-bar-wrap medium">
                  <h3>Medium</h3>
                  <div className="mobility-bar">
                    <span></span>
                  </div>
                </div>
                <div className="mobility-bar-wrap low">
                  <h3>Low</h3>
                  <div className="mobility-bar">
                    <span></span>
                  </div>
                </div> */}
              </div>
              <div className="btn-wrap-sec report-btn-wrap">
                {/* <IonButton className="generic-btn">
                  View Assessment Notes
                </IonButton> */}
                <Link
                  to="/assessment-notes"
                  className="ancher-generic-btn text-dec-none "
                >
                  View Assessment Notes
                </Link>

                <Link
                  to="/patient-page"
                  className="ancher-generic-btn text-dec-none return-patient-btn"
                >
                  Return to Patient Profile
                </Link>

                {/* <IonButton className="generic-btn return-btn">
                  Return to Patient Profile
                </IonButton> */}
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
export default ReportPage;
